function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Trans } from "@lingui/react";
import { i18n } from "@lingui/core";
import React from 'react';
import { Avatar } from '@prezi/avatar';
import * as CommonComponents from '@prezi/common-components';
import { useRTL } from '@prezi/common-components';
import { neutral80, orange300 } from '@prezi/common-design';
import * as Atoms from '../../atoms';
import { createDataLookup, TOOLTIP_ROOT } from '../../const';
import styled from 'styled-components';
import { getPermissionOptionsUpdate, PermissionValueNoAccess } from '../../../utils/permissions';
import { isPermissionAllowed } from '../../../api/userPermissions';
import { isNil } from 'ramda';
import { DropdownSelect, DropdownItem } from '@prezi/bento';
const Wrapper = styled.div.withConfig({
  displayName: "Collaborator__Wrapper",
  componentId: "sc-1u073zq-0"
})(["display:flex;align-items:center;margin:10px 0;width:100%;"]);
const DetailsWrapper = styled.div.withConfig({
  displayName: "Collaborator__DetailsWrapper",
  componentId: "sc-1u073zq-1"
})(["display:flex;align-items:center;flex:1 1 auto;"]);
const SelectWrapper = styled.div.withConfig({
  displayName: "Collaborator__SelectWrapper",
  componentId: "sc-1u073zq-2"
})(["flex:1 1 130px;display:flex;justify-content:flex-end;margin-inline-end:-8px;"]);
const Pending = styled.span.withConfig({
  displayName: "Collaborator__Pending",
  componentId: "sc-1u073zq-3"
})(["color:", ";"], orange300);
const MaybeAvatar = ({
  isPendingInvite,
  avatarProps
}) => isPendingInvite ? React.createElement(Avatar, {
  size: 30,
  firstName: '',
  lastName: ''
}) : avatarProps.isOrganization ? React.createElement(Atoms.Dumb.TeamAvatar, null) : React.createElement(Avatar, _extends({
  size: 30
}, avatarProps));
const generateDisplayNameText = ({
  label,
  firstName,
  lastName,
  isCurrentUser
}) => {
  if (label) {
    return label;
  } else {
    const displayName = firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || '';
    return isCurrentUser ? `${displayName} (${i18n._("You")})` : displayName;
  }
};
const DropdownItemRemove = styled(DropdownItem).withConfig({
  displayName: "Collaborator__DropdownItemRemove",
  componentId: "sc-1u073zq-4"
})(["&&{box-shadow:0 1px 0 0 ", " inset;}"], neutral80);
const OwnerSelect = () => {
  const {
    isRTL
  } = useRTL();
  return React.createElement(DropdownSelect, {
    options: [{
      label: i18n._("Owner"),
      value: 'owner'
    }],
    value: "owner",
    disabled: true,
    dataLookup: createDataLookup('owner-permissions-select'),
    outline: false,
    align: isRTL ? 'left' : 'right'
  });
};
const addRemoveOption = (options, isOwnerOrEditor, onRemove, isCurrentUser) => isOwnerOrEditor || !!isCurrentUser ? options.concat([{
  value: undefined,
  label: i18n._("Remove"),
  Component: () => React.createElement(DropdownItemRemove, {
    iconLeft: React.createElement(CommonComponents.SelectIconPlaceholder, null),
    onClick: onRemove,
    "data-lookup": createDataLookup('remove-collaborator-option')
  }, React.createElement(Trans, {
    id: "remove"
  }))
}]) : options;
export default (({
  label,
  caption,
  avatarProps,
  permission,
  onChange,
  onRemove,
  currentUserData,
  isOwner = false,
  isPendingInvite = false,
  isDisabled = false
}) => {
  const {
    isRTL
  } = useRTL();
  const {
    firstName,
    lastName,
    isCurrentUser
  } = avatarProps;
  const hasEditorRightOrOwner = currentUserData.isOwner || isPermissionAllowed(currentUserData.updateCollaboratorsPermissions.editor);
  const updatePermissionOptions = getPermissionOptionsUpdate(currentUserData.updateCollaboratorsPermissions, permission, currentUserData.isOwner);
  return React.createElement(Wrapper, null, React.createElement(DetailsWrapper, null, React.createElement(MaybeAvatar, {
    isPendingInvite: isPendingInvite,
    avatarProps: avatarProps
  }), React.createElement(CommonComponents.UserDisplayContainer, null, React.createElement(CommonComponents.UserDisplayName, {
    size: 14,
    "data-lookup": createDataLookup('collaborator-display-name')
  }, isPendingInvite ? React.createElement(Pending, null, i18n._("Invitation pending")) : React.createElement("span", null, generateDisplayNameText({
    label,
    firstName,
    lastName,
    isCurrentUser
  }))), React.createElement(CommonComponents.UserDisplayCaption, {
    size: 12
  }, caption))), React.createElement(SelectWrapper, null, isOwner ? React.createElement(OwnerSelect, null) : React.createElement(DropdownSelect, {
    options: addRemoveOption(updatePermissionOptions.options, hasEditorRightOrOwner, onRemove, isCurrentUser),
    value: permission.value,
    disabled: !isCurrentUser && (isDisabled || updatePermissionOptions.disabled),
    portalRoot: TOOLTIP_ROOT,
    onChange: p => !isNil(p) && p !== PermissionValueNoAccess.NO_ACCESS && onChange(p),
    dataLookup: createDataLookup('collaborator-permissions-select'),
    fitItems: true,
    outline: false,
    align: isRTL ? 'left' : 'right'
  })));
});